<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.value") {{ $t("ui." + option.text.toLowerCase()) }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [
      {
        value: "INBOX",
        text: "INBOX"
      },
      {
        value: "CREDIT",
        text: "CREDIT"
      },
      {
        value: "PRIZE",
        text: "PRIZE"
      }
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
